import React, { useState, useEffect } from "react";
import CheckoutForms from "../../Checkout/CheckoutForms";
import "../../Checkout/CheckoutModal.css";
import { Dialog, DialogActions, DialogTitle, DialogContent, Button, Alert, CircularProgress } from "@mui/material";
import axios from 'axios';
import { APIURL } from '../../../config';

export default function ViewFormModal(props) {
    const [selectedForm, setSelectedForm] = useState(null);
    const [forms, setForms] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!props.show || !props.task_id) return;
        let active = true;
        setLoading(true);
        setError('');
        setSelectedForm(null);
        axios.get(APIURL + `/customer_form/task/${props.task_id}`)
            .then(response => {
                if (!Array.isArray(response.data)) throw new Error('Unexpected forms response');
                if (!active) return;
                // Key everything by the underlying form template ID: task_form rows use form_id,
                // customer_form submissions (from here or from props) use form_type.
                const templateId = (form) => String(form.form_type ?? form.form_id);
                const merged = new Map();
                (props.forms || []).forEach(form => merged.set(templateId(form), form));
                response.data.forEach(form => merged.set(templateId(form), { ...form, form_id: form.form_type }));
                setForms([...merged.values()]);
            })
            .catch(() => { if (active) setError('Unable to load attached forms. Close and reopen to retry.'); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [props.forms, props.show, props.task_id]);
    

    return (
        <div>
            <Dialog 
                open={props.show} 
                onClose={props.hide} 
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>Forms</DialogTitle>
                <DialogContent>
                    {loading && <CircularProgress size={24} />}
                    {error && <Alert severity="error">{error}</Alert>}
                    {!loading && !error && <CheckoutForms
                        forms={forms} 
                        customer_id={props.cus_id}
                        customer_name={props.customer_name}
                        task_id={props.task_id}
                        taskDetails={props.taskDetails}
                        selectedForm={selectedForm}
                        setSelectedForm={setSelectedForm}
                        user_id={props.user_id}
                        readOnly={props.isTimeSheetControl ? false : true}
                    />}
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={props.hide}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

